export class AtsCandidateApi {
    constructor(httpRequest) {
        this.httpRequest = httpRequest;
    }
    /**
     * Get contact with ATS data by linkedin url or contact ID
     * @returns ContactWithAtsDataDto
     * @throws ApiError
     */
    getContactWithAtsData({ linkedinUrl, contactId, }) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/ats-candidate',
            query: {
                'linkedinUrl': linkedinUrl,
                'contactId': contactId,
            },
        });
    }
}
